import { render, staticRenderFns } from "./capitalAccountList.vue?vue&type=template&id=48594a64"
import script from "./capitalAccountList.vue?vue&type=script&lang=js"
export * from "./capitalAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports